import React from 'react';

interface EmptyCellProps {
  className?: string;
}

export const EmptyCell: React.FC<EmptyCellProps> = props => (
  <div className={props.className} {...props} />
);
